import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 16px;
  cursor: pointer;
`;
